module.exports = __webpack_public_path__ + "img/slp-pe.fc2c5ad1.png";